<template>
  <main
    class="flex min-h-screen flex-col items-center justify-start bg-gray-100 p-4"
  >
    <slot />
  </main>
</template>
